import React from 'react';
import { HeadphonesIcon } from 'lucide-react';
export const genreColors: Record<string, string> = {
  Fantasy: 'bg-indigo-600',
  Romance: 'bg-pink-600',
  Mystery: 'bg-purple-600',
  Thriller: 'bg-red-600',
  Horror: 'bg-gray-900',
  SciFi: 'bg-blue-600',
  'Sci-Fi': 'bg-blue-600',
  Adventure: 'bg-green-600',
  Historical: 'bg-amber-700',
  Contemporary: 'bg-teal-600',
  default: 'bg-gray-600'
};
export const formatIcons: Record<string, React.ReactNode> = {
  audio: <HeadphonesIcon className="h-3 w-3" data-id="element-20224" data-mp="63b4xeufsmfw" />
};